// extracted by mini-css-extract-plugin
export default {"divider":"myCV_divider__4aoc1"};